import { render, staticRenderFns } from "./TaxaView.vue?vue&type=template&id=50816c38&scoped=true&"
import script from "./TaxaView.vue?vue&type=script&lang=js&"
export * from "./TaxaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50816c38",
  null
  
)

export default component.exports